import { bulkSignOrchestratorApi } from "@rshbintech.dboul/http";
import { BatchedDocumentsItemMap, CheckSignatureRequest } from "../types";
import {
  DOCUMENT_SIGNING_STAGES,
  UNKNOWN_SIGNATURE_CHECK_ERROR,
} from "../constants";
import { isErrorEvent } from "./is-error-event";
import { isErrorInfo } from "./is-error-info";

export const checkSignatures = async (
  taskId: string,
  isSigning: boolean,
  batches?: BatchedDocumentsItemMap
) => {
  if (!batches) {
    return;
  }

  const documentsToCheck: CheckSignatureRequest[] = [];

  Object.values(batches).forEach((document) => {
    if (
      !document.signatureInfo.error &&
      document.signatureInfo.signature &&
      document.signatureInfo.signingStage ===
        DOCUMENT_SIGNING_STAGES.SIGNED_LOCALLY
    ) {
      documentsToCheck.push({
        id: document.id,
        type: document.type.code,
        system: document.systemShortName,
        signature: document.signatureInfo.signature,
      });
    }
  });

  if (documentsToCheck.length) {
    try {
      const response = isSigning
        ? await bulkSignOrchestratorApi.api.checkSignatures(taskId, {
            documents: documentsToCheck,
          })
        : await bulkSignOrchestratorApi.api.checkViseSignatures(taskId, {
            documents: documentsToCheck,
          });

      if (response.ok) {
        documentsToCheck.forEach(
          (document) =>
            (batches[document.id].signatureInfo.signingStage =
              DOCUMENT_SIGNING_STAGES.SIGNATURE_IS_CHECKING)
        );

        return batches;
      }
    } catch (error) {
      const errorData = isErrorEvent(error) ? error.error : error;

      documentsToCheck.forEach((document) => {
        if (isErrorInfo(errorData)) {
          batches[document.id].signatureInfo.error = errorData.message;
          batches[document.id].signatureInfo.signingStage =
            DOCUMENT_SIGNING_STAGES.SIGNATURE_IS_CHECKING;
        } else if (errorData && typeof errorData === "string") {
          batches[document.id].signatureInfo.error = errorData;
          batches[document.id].signatureInfo.signingStage =
            DOCUMENT_SIGNING_STAGES.SIGNATURE_IS_CHECKING;
        } else {
          batches[document.id].signatureInfo.error =
            UNKNOWN_SIGNATURE_CHECK_ERROR;
          batches[document.id].signatureInfo.signingStage =
            DOCUMENT_SIGNING_STAGES.SIGNATURE_IS_CHECKING;
        }
      });
    }
  }
};
